import { ChangeEvent, useEffect, useState } from "react";
import { ICustomerConfirmationProps, ICustomerConfirmationStates } from "./interfaces";
import { Core } from "../../components/infrastructure/core";
import { enmEntityState } from "../../components/infrastructure/models";
import { Button, Form, Radio, RadioChangeEvent } from "antd";
import { StopOutlined, CheckCircleOutlined } from '@ant-design/icons';
import TextArea from "antd/lib/input/TextArea";

type LayoutType = Parameters<typeof Form>[0]['layout'];

export const CustomerConfirmation = (props: ICustomerConfirmationProps) => {

    const [state, setState] = useState<ICustomerConfirmationStates>({ loading: false, entity: props.entity ?? { RowGuid: Core.newId(), State: enmEntityState.Added } as any });
    const [form] = Form.useForm();

    const formItemLayout = {
        labelCol: { xxl: 6, xl: 6, lg: 8, md: 8, sm: 10, xs: 24 },
        wrapperCol: { xxl: 12, xl: 12, lg: 16, md: 16, sm: 14, xs: 24 }
    };

    const [formLayout] = useState<LayoutType>('horizontal');

    useEffect(() => {
        //const { CustomerConfirmation } = state;
        //if (!CustomerConfirmation) {
        //    setState({ CustomerConfirmation: { RowGuid: Core.newId(), State: enmEntityState.Added } as any });
        //}
    }, []);

    const submit = async () => {
        const { entity } = state;
        if (!entity)
            return;

        setState({ ...state, loading: true });
        const data = {
            data: {
                TicketNo: props.repairCase.TicketNo,
                Description: entity.Description,
                Confirm: entity.Confirm
            }
        };

        if (props.onSubmit)
            await props.onSubmit({
                data,
                url: "portal/repairationconfirmation",
                completeCallback: result => {
                    setState({ ...state, loading: false });
                    if (result.ValidationState.Successful) {
                        Core.successNotification('اعلام نظر با موفقیت انجام شد');
                        props.onClose && props.onClose({ preventBack: true });
                    }
                }
            });
    };

    const onChangeConfirm = (e: RadioChangeEvent) => {
        const { entity } = state;
        entity.Confirm = e.target.value;
        setState({ ...state, entity });
    };

    const onChangeDescription = (e: ChangeEvent<HTMLTextAreaElement>) => {
        const { entity } = state;
        entity.Description = e.target.value;
        setState({ ...state, entity });
    };

    return (
        <Form
            form={form}
            scrollToFirstError
            {...formItemLayout}
            layout={formLayout}
            onFinish={submit}
            onReset={() => {
                props.onClose && props.onClose(this);
            }}
            style={{ padding: 0 }}
        >
            <Form.Item
                label={'آیا با مبلغ برآورد شده موافق هستید؟'}
                name={'Confirm'}
                key={'Confirm'}
                rules={[{ required: true, message: 'پاسخ اجباری است' }]}
                initialValue={state.entity.Confirm}
                labelCol={{ style: { lineHeight: 'normal' } }}
            >
                <Radio.Group key={'Confirm'}
                    onChange={onChangeConfirm}
                    buttonStyle={"solid"}
                    disabled={props.disabled}
                >
                    <Radio value={true}>بله موافق هستم، تعمیرات انجام شود</Radio>
                    <Radio value={false}>خیر، انصراف می دهم</Radio>
                </Radio.Group>
            </Form.Item>

            <Form.Item
                label={'توضیحات'}
                name={'Description'}
                key={'Description'}
                //rules={[{ required: !state.entity.Confirm, message: 'توضیحات اجباری است' }]}
                initialValue={state.entity.Description}
            >
                <TextArea
                    onChange={onChangeDescription}
                    disabled={props.disabled}
                    rows={6}
                />
            </Form.Item>

            {props.disabled === true ? <></> :
                <Form.Item wrapperCol={{ dir: 'ltr' }} style={{ zIndex: 1000, borderTop: '1px solid', borderColor: '#e5e5e5', marginTop: 10 }}>
                    <Button type="primary" htmlType="submit" icon={<CheckCircleOutlined />} loading={state.loading} style={{ width: "100px", marginTop: 10, marginBottom: 10 }}>
                        ثبت
                    </Button>

                    <Button type="ghost" htmlType="reset" icon={<StopOutlined />} loading={state.loading} style={{ width: "100px", marginTop: 10, marginBottom: 10, marginLeft: 10, background: '#fff' }}>
                        لغو
                    </Button>
                </Form.Item>
            }
        </Form>
    );
}